global.$ = global.jQuery = require("jquery");
import "bootstrap";
import "select2";
import "lightbox2";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

window.toastr = require("toastr");
window.Swiper = Swiper

require("select2/dist/js/i18n/it.js");

let countDowns =[];


(function ($) {
    $("document").ready(function () {
        refreshCountdowns();
        $(".toast").toast();

        // MENU
        $("#menu-principale .dropdown-toggle, .att-user-menu .dropdown-toggle").on("click", function () {
            var parent = $(this).parent(".nav-link");
            var dropdown = parent.next(".dropdown");
            $(this).toggleClass("opened");
            dropdown.toggle();
        });
        $(".navbar-toggler").on("click", function () {
            $("body").toggleClass("noscroll");
            $("nav.navbar").toggleClass("nav-scrollable");
        });

        // menu-principale dropdown
        const navLinkAste = $("#menu-principale .aste-menu-item").first();
        const mainMenu = $('#menu-principale');
        const logoContainer = $('.logo-container');
        navLinkAste.find('.dropdown-toggle').unbind('click');
        navLinkAste.on({
            mouseenter: function mouseenter() {
                $(this).find('.dropdown.aste-menu-item').stop().addClass('show');
            },
            mouseleave: function mouseleave() {
                $(this).find('.dropdown.aste-menu-item').stop().removeClass('show');
            }
        });
        function assignOffsetSubMenuAste() {
            if ($(window).width() >= 992) {
                navLinkAste.find(".aste-menu-item__typology-wrapper-links").css('margin-left', parseInt(mainMenu.css('margin-left')) + logoContainer.outerWidth(true));
            }
        }
        assignOffsetSubMenuAste(navLinkAste);
        window.addEventListener('resize',() => assignOffsetSubMenuAste(navLinkAste));

        const navLinkTypology1 = $(".aste-menu-item__typology-link[data-link='aste-menu-item__typology-1']");
        const navLinkTypology2 = $(".aste-menu-item__typology-link[data-link='aste-menu-item__typology-2']");
        navLinkTypology1.on({
            mouseenter: function mouseenter() {
                $(".aste-menu-item__typology-wrapper-dropdown ."+navLinkTypology2.data('link')).slideUp(400);
                $(".aste-menu-item__typology-wrapper-dropdown ."+$(this).data('link')).stop(true, false).slideDown(400);
            },
            mouseleave: function mouseleave() {
                if ($('.aste-menu-item__typology-wrapper-dropdown .'+$(this).data('link')+":hover").length === 0) {
                    $('.aste-menu-item__typology-wrapper-dropdown .'+$(this).data('link')).stop(true, false).slideUp(400);
                }
            }
        });
        navLinkTypology2.on({
            mouseenter: function mouseenter() {
                $(".aste-menu-item__typology-wrapper-dropdown ."+navLinkTypology1.data('link')).slideUp(400);
                $(".aste-menu-item__typology-wrapper-dropdown ."+$(this).data('link')).stop(true, false).slideDown(400);
            },
            mouseleave: function mouseleave() {
                if ($('.aste-menu-item__typology-wrapper-dropdown .'+$(this).data('link')+":hover").length === 0) {
                    $('.aste-menu-item__typology-wrapper-dropdown .'+$(this).data('link')).stop(true, false).slideUp(400);
                }
            }
        });

        // Default focus on open select2 field
        $(document).on('select2:open', () => {
            document.querySelector('.select2-search__field').focus();
        });

        // Global search
        $('#show-form').click(function (e) {
            $('#site-search-overlay-level').toggleClass('d-lg-none');
        })
        $('#hide-form').click(function (e) {
            $('#site-search-overlay-level').addClass('d-lg-none');
            $('#input-sitesearch-desktop').val('').submit();
        })

        // AUCTION LOCATION SELECT2
        // Homepage
        $(".home-desktop-search-form .auction-city").select2({
            minimumInputLength: 2,
            language: "it",
            containerCssClass: "custom-select col-auto",
        });
        $(".home-mobile-search-form .auction-city, #att-form-query-auctions .auction-city").select2({
            minimumInputLength: 2,
            language: "it",
            containerCssClass: "custom-select box-shadow-strong",
        });

        // OTHERS SELECT2
        // Homepage
        $(".home-desktop-search-form .auction-area").select2({
            language: "it",
            minimumResultsForSearch: -1,
            containerCssClass: "custom-select col-auto",
        });
        // Auctions search form
        $("#att-form-query-auctions select:not(.auction-city)").select2({
            language: "it",
            minimumResultsForSearch: -1,
            containerCssClass: "custom-select box-shadow-strong",
        });
        $(".att-home-category-select, #form-ricerca-risultati-ordina select").select2({
            language: "it",
            minimumResultsForSearch: -1,
            containerCssClass: "custom-select",
        });

        // Home search
        $("select.auction-area").change(function () {
            var form = $("#att-form-home-desktop-search");

            // Toggle city select only for estate auctions
            if ($(this).val() == "estate") {
                form.find(".auction-city-container").show();
            } else {
                form.find(".auction-city-container").hide();
            }

            // Toggle auction typology for estates, name for goods
            form.find("input[name=auction_typology]").toggle();
            form.find("input[name=auction_name]").toggle();

            // Change form action
            var optionSelected = $(this).find(":selected");
            form.attr("action", optionSelected.data("action"));
        });


        if ($("#att-subscribe-sms-notifications-ok-modal").length) {
            $("#att-subscribe-sms-notifications-ok-modal").modal("show");
        }

        // Add to favourite
        $(".att-toggle-favourite").on("click", function () {
            let goodId = $(this).data("auction");
            let action = $(this).data("action");
            let data = {
                good_id: goodId,
                add_remove: action
            }
            $.request('onAddRemoveFavorite', {
                data: data,
            }).done(function (result) {
                let dataRes=JSON.parse(result.result)
                if(dataRes.good_id && data.add_remove === 'add'){
                    $('.att-toggle-favourite').data('action', 'remove');
                    $('.att-toggle-favourite .att-heart-text').text('Rimuovi dai Preferiti');
                    $('.att-toggle-favourite .att-heart-image').attr('src', '/themes/aste33/assets/images/heart.svg');
                    avviso('Aste preferite', 'Aggiunto ai preferiti', '', 0);
                } else{
                    $('.att-toggle-favourite').data('action', 'add');
                    $('.att-toggle-favourite .att-heart-text').text('Aggiungi ai Preferiti');
                    $('.att-toggle-favourite .att-heart-image').attr('src', '/themes/aste33/assets/images/empty-heart.svg');
                    avviso('Aste preferite', 'Rimosso dai preferiti', '', 0);
                }
            })
        });

        // scroll body to 0px on click
        $(".att-back-to-top > div").click(function () {
            $("body,html").animate(
                {
                    scrollTop: 0,
                },
                800
            );
            return false;
        });

        var h_header = $("header .container-big").height();

        // scroll btn to div on click
        $(".btn-scroll").click(function () {
            var divToScroll = $(this).attr("href");

            var h_scrollTop = $("" + divToScroll + "").offset().top;

            // se sono in modalità mobile aggiungo anche l'altezza dell'header
            var vw = $(this).width();
            if (vw <= 768) {
                h_scrollTop = h_scrollTop - h_header - 15;
            }

            $("body,html").animate(
                {
                    scrollTop: h_scrollTop,
                },
                800
            );
            return false;
        });

        // -- ARROW SCROLL DOWN ---
        $("#scroll_down").fadeIn();

        if (
            $("body").hasClass("famigliaProdotti") ||
            $("body").hasClass("categoria")
        ) {
            h_header = h_header + $("div.menu_famiglia").height();
            if ($("body").hasClass("famigliaProdotti")) {
                h_header = h_header + $(".menu_famiglia_top").height();
            }
        }
        var h_main = $(window).height() - h_header;

        $(window).scroll(function () {
            if ($(this).scrollTop() > 0) {
                $("#scroll_down.position-absolute").fadeOut();
            } else {
                $("#scroll_down.position-absolute").fadeIn();
            }
        });

        // scroll body to 0px on click
        $("#scroll_down").click(function () {
            $("#scroll_down.position-absolute").fadeOut();
            $("body,html").animate(
                {
                    scrollTop: h_main,
                },
                800
            );
            return false;
        });

        // textarea che si adatta al testo scritto
        var txt = $("textarea#imailfld_message"),
            hiddenDiv = $(document.createElement("div")),
            content = null,
            contentHeight;

        txt.addClass("txtstuff");
        hiddenDiv.addClass("hiddendiv common");

        $("body").append(hiddenDiv);

        txt.on("keyup", function () {
            content = $(this).val();

            //content = content.replace(/\n/g, '<br>');
            hiddenDiv.html(content);

            contentHeight = Math.max(45, hiddenDiv.height());

            $(this).css("height", contentHeight);

            if (content === "") {
                $(this).css("height", "45px");
            }
        });


        // header mobile
        //fixHeaderPos();

        $(document).bind("gform_confirmation_loaded", function (event, formId) {
            // Contacts
            if (formId == 2) {
                window.dataLayer.push({
                    event: "submit-form-contatti-ok",
                });
            }

            // Book visit
            if (formId == 3) {
                window.dataLayer.push({
                    event: "submit-form-visita-ok",
                });
                $("#att-book-visit-modal .modal-footer").show();
                $("#att-book-visit-modal .modal-header").hide();
            }
        });

        $("#billing_person_type").on("change", function () {
            var fieldsToHide = [];
            var fieldsToShow = [];

            if ($(this).val() == "legal") {
                fieldsToHide = ["billing_fiscal_code"];
                fieldsToShow = [
                    "billing_vat_number",
                    "billing_certified_email",
                    "billing_company",
                    "billing_receiver_code",
                ];
            } else {
                fieldsToHide = [
                    "billing_vat_number",
                    "billing_certified_email",
                    "billing_company",
                    "billing_receiver_code",
                ];
                fieldsToShow = ["billing_fiscal_code"];
            }

            for (var i = 0; i < fieldsToHide.length; i++) {
                $(`#${fieldsToHide[i]}_field`)
                    .addClass("d-none")
                    .removeClass("validate-required");
            }

            for (var i = 0; i < fieldsToShow.length; i++) {
                $(`#${fieldsToShow[i]}_field`)
                    .removeClass("d-none")
                    .addClass("validate-required");
            }
        });

        /**
         * ==============================================================================
         * ==============================================================================
         * ===============================ASTA ONLINE====================================
         * ==============================================================================
         * ==============================================================================
         */

        $("select#Checkbox").select2({
            minimumResultsForSearch: -1,
            containerCssClass: "custom-select box-shadow-strong",
        });

        $("#att-sms-notifications input[name=Checkbox]").on(
            "change",
            function () {
                var isChecked = $(this).is(":checked");
                var v = $(this).val();

                var element =
                    v == "SMS"
                        ? $(".form-group.PhoneNumber_countrycode")
                        : $(".form-group.Email");

                if (isChecked) {
                    element.show();
                    element.find("input").prop("required", true);
                } else {
                    element.hide();
                    element.find("input").prop("required", false);
                }
            }
        );

        // Gallery in good page
        const singleGoodGallery = new Swiper('.auction-gallery', {
            loop: true,
            navigation: {
                nextEl: '.carousel-control-next',
                prevEl: '.carousel-control-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
        });

        // Gallery in listing good
        listGoodGallery();
        window.reloadListGoodGallery = ()=> {
            listGoodGallery();
        };

    });

    function refreshCountdowns(){
        countDowns.forEach(function (elem){
            clearInterval(elem)
        })
        countDowns=[]

        $('.auction-timer').each(function( index ) {
            let id = $( this ).attr('id')
            let time =$(this).data("time")
            countDowns.push(countDownTimer(time, id))
        });

        // if ($("#auction-timer").length > 0) {
        //     var endTime = $("#auction-timer").data("time")
        //     countDowns.push(countDownTimer(endTime, "auction-timer"))
        // }
        // if ($("#auction-timer-not-started").length > 0) {
        //     var startTime = $("#auction-timer-not-started").data("time")
        //     countDowns.push(countDownTimer(startTime, "auction-timer-not-started"))
        // }
        // if ($("#auction-timer-not-started-no-paid").length > 0) {
        //     var endTimeNotStarted = $("#auction-timer-not-started-no-paid").data("time");
        //     countDowns.push(countDownTimer(endTimeNotStarted,"auction-timer-not-started-no-paid"))
        // }
        // if ($("#auction-timer-relisted").length > 0) {
        //     var endTimeRelisted = $("#auction-timer-relisted").data("time")
        //     countDowns.push(countDownTimer(endTimeRelisted, "auction-timer-relisted"))
        // }
    }

    /** LNK Auction Timer Functions **/
    function countDownTimer(dt, id) {
        var end = new Date(dt);

        var _second = 1000;
        var _minute = _second * 60;
        var _hour = _minute * 60;
        var _day = _hour * 24;
        var timer;

        function showRemaining() {
            var now = new Date();

            var distance = end - now;
            if (distance < 0) { // auction finish
                let norefresh =  $('#'+id).data('endnorefresh')
                if(!norefresh){
                    clearInterval(timer);
                    location.reload();
                }
                return;
            }
            var arr_vals=[
                {
                  'value': Math.floor(distance / _day),
                  'label': 'giorni',
                  's_label':'giorno'
                },
                {
                  'value': Math.floor(distance % _day / _hour),
                  'label': 'ore',
                  's_label':'ora'
                },
                {
                  'value': Math.floor(distance % _hour / _minute),
                  'label': 'minuti',
                  's_label':'minuto'
                },
                {
                  'value': Math.floor(distance % _minute / _second),
                  'label': 'secondi',
                  's_label':'secondo'
                },
            ]
            var html='';
            arr_vals.forEach( function (elem){
                html+="<span class='bold px-1'> "+ elem.value + "</span>";
                if(elem.value==1){
                    html+=elem.s_label;
                }
                else{
                    html+=elem.label;
                }
            });

            let elem=document.getElementById(id)
            if(elem){
                elem.innerHTML = html
            }
        }
        timer = setInterval(showRemaining, 1000);
        return timer;
    }

    function showToast(name, body = false) {
        var prefab = $("#toast-prefabs > .toast-" + name).html();
        $("#toasts-container").append(prefab);

        var toast = $("#toasts-container > .toast:last-child");

        if (body) {
            toast.find(".toast-body").html(body);
        }

        toast.toast("show");
        toast.on("hidden.bs.toast", function () {
            this.remove();
        });
    }

    $(window).resize(function () {
        var vw = $(this).width();

        //fixHeaderPos();
    });



    // header mobile
    function fixHeaderPos() {
        var section = $("main .intro");
        var vw = $(this).width();

        // solo l'homepage non ha padding sopra,
        // perchè come intro ha due sezioni che occupano metà schermo in altezza
        if ($("body").hasClass("home")) {
            if (vw < 1200) {
                var h_header = $("header .container-big").height();
                section.css("padding-top", h_header + "px");
            } else {
                section.css("padding-top", 0 + "px");
            }
        } else {
            var h_header = $("header").height();
            if (vw < 992) {
                section.css("padding-top", h_header + "px");
            } else {
                h_header = h_header + 33;
                section.css("padding-top", h_header + "px");
            }
        }
    }

    // Needs validation
    var needsValidation = document.getElementsByClassName("needs-validation");
    var validation = Array.prototype.filter.call(
        needsValidation,
        function (form) {
            form.addEventListener(
                "submit",
                function (event) {
                    if (form.checkValidity() === false) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    form.classList.add("was-validated");
                },
                false
            );
        }
    );

    /** LNK **/
    /** LNK WS Auctions - Auctions WS Connection **/

    jQuery(document).ready(function ($) {
        toastr.options = {
            closeButton: true,
            debug: false,
            newestOnTop: true,
            progressBar: true,
            positionClass: "toast-top-right",
            preventDuplicates: false,
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "5000",
            extendedTimeOut: "5000",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut",
        };

    });
    /** LNK WS Auctions - Auctions Functions **/
    function normalize(data) {
        data.user_agent = navigator.userAgent;
        return JSON.stringify(data);
    }

    function avviso(title, message, value, tipo) {
        switch (tipo) {
            case 1:
                toastr.warning(message, title);
                break;
            case 2:
                if ($('#contatore_utenti').length > 0) {
                    $("#contatore_utenti").html(value);
                    //   toastr.success("count:"+count, title);
                }
                break;
            case 3:
                toastr.error(message, title);
                break;
            default:
                toastr.info(message, title);
        }
    }

    // Edit Account form
    if ($("#editAccountForm").length > 0 || $("#cartAccountFields").length > 0) {
        setAccountFields(false);
        $(document).on("change", "#billing_person_type", function () {
            setAccountFields(true);
        });
    }

    // $(document).on("change", "#billing_country", function () {
    //     var countryId = $(this).val();
    //     $.request("onGetStates", {
    //         data: { countryId: countryId },
    //         success: function (data) {
    //             var html = "";
    //             if (data.status == true) {
    //                 html = '<option value="">Seleziona una Provincia</option>';
    //                 $.each(data.states, function (index, state) {
    //                     html +=
    //                         '<option value="' +
    //                         state.id +
    //                         '">' +
    //                         state.name +
    //                         "</option>";
    //                 });

    //                 $("#billing_state").empty().append(html);
    //                 $(".optional").empty().text("*");
    //             } else {
    //                 $("#billing_state").empty();
    //                 $(".optional").empty().text("(optional)");
    //             }
    //         },
    //     });
    // });


    function setAccountFields(onChange = false) {
        let $type = $("#billing_person_type");

        if (onChange) {
            sessionStorage.setItem("billing_person_type", $type.val())
        } else {
            if (sessionStorage.getItem("billing_person_type")) {
                $type.val(sessionStorage.getItem("billing_person_type")).prop('selected', true)
            }
        }

        let fisicaFields = ["billing_fiscal_code_field"];
        let giuridicaFields = [
            "billing_company_field",
            "billing_vat_number_field",
            "billing_certified_email_field",
            "billing_receiver_code_field",
            "visura_camerale_field"
        ];
        if ($type.val() === "fisica") {
            $.each(fisicaFields, function (index, val) {
                $("#" + val).removeClass("d-none");
            });
            $.each(giuridicaFields, function (index, val) {
                $("#" + val).addClass("d-none").children("input").val("");
            });
        } else {
            $.each(fisicaFields, function (index, val) {
                $("#" + val).addClass("d-none").children("input").val("");
            });
            $.each(giuridicaFields, function (index, val) {
                $("#" + val).removeClass("d-none");
            });
        }
    }

    function scrollToEl(anchor) {
        let to = $(anchor);
        if (to.length === 0) {
            return;
        }
        $("html, body").animate({ scrollTop: to.offset().top }, 500);
    }

    function setCookie(name,val,days) {
        let expiry = new Date();
        let now = new Date();
        expiry.setTime(now.getTime() + (parseInt(days)*24*60*60000));
        document.cookie = name + '=' + escape(val) + '; expires=' + expiry.toGMTString() + '; path=/';
    }

    function getCookie(name) {
        let cookieArr = document.cookie.split(";");
        for(var i = 0; i < cookieArr.length; i++) {
            var cookiePair = cookieArr[i].split("=");
            if(name === cookiePair[0].trim()) {
                return decodeURIComponent(cookiePair[1]);
            }
        }
        return null;
    }

    var auctionGalleryListIstances = {};
    function listGoodGallery() {
        $('.auction-gallery-list').each(function (index) {
            let nextElClass = 'carousel-control-next--' + index;
            let prevElClass = 'carousel-control-prev--' + index;
            let paginationClass = 'swiper-pagination--' + index;
            $(this).addClass('gallery-'+index);
            $(this).find('.carousel-control-next').addClass(nextElClass);
            $(this).find('.carousel-control-prev').addClass(prevElClass);
            $(this).find('.swiper-pagination').addClass(paginationClass);
            auctionGalleryListIstances[index] = new Swiper('.gallery-'+index, {
                loop: true,
                lazy: {
                    enabled: true,
                    loadOnTransitionStart: true,
                },
                navigation: {
                    nextEl: '.' + nextElClass,
                    prevEl: '.' + prevElClass,
                },
                pagination: {
                    el: '.' + paginationClass,
                    type: 'fraction',
                },
            });
        })
    }

    // Toggle Password Eye
    document.querySelectorAll(".passwordEye").forEach(el =>
        el.addEventListener('click',() => clickEyePassword(el) )
    )
    function clickEyePassword(el) {
        if (!el) {el = this}
        let inputEl = document.querySelector('#'+el.getAttribute('data-input'));
        inputEl.getAttribute('type') === 'password' ? inputEl.type='text' : inputEl.type='password';
        el.querySelector('i').classList.toggle("fa-eye");
        el.querySelector('i').classList.toggle("fa-eye-slash");
    }
    window.clickEyePassword = clickEyePassword;

    // Toggle submit enable by checking privacy
    $('.privacy-cb-submit').click(function () {
        if($(this).prop('checked') != true) {
            $('.privacy-button-submit').prop('disabled', true);
        } else {
            $('.privacy-button-submit').prop('disabled', false);
        }
    })

})(jQuery);

$(".c-trigger").on('click', function () {


    if ($('.c-trigger').hasClass('opened')) {
        $(this).removeClass('opened');

    } else {
        $(this).addClass('opened');
    }
});
